import { type ReactNode } from 'react'

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/atoms/Accordion'

export type SettingsAccordionItemProps = { value: string; trigger: ReactNode; children: ReactNode }

// One collapsible form inside a SettingsCard. The form stays mounted while closed so a draft survives
// collapsing it, and its footer only rounds its corners on the item that ends the card.
export function SettingsAccordionItem({ value, trigger, children }: SettingsAccordionItemProps) {
  return (
    <AccordionItem
      value={value}
      className="tw:last:border-b-0 tw:not-last:**:data-[slot=settings-form-footer]:rounded-none"
    >
      <AccordionTrigger>{trigger}</AccordionTrigger>
      <AccordionContent forceMount className="tw:-mx-5 tw:in-data-[state=closed]:hidden">
        {children}
      </AccordionContent>
    </AccordionItem>
  )
}
